import { useContext, Context } from 'react';

const useRequiredContext = <T, TValue = T | null | undefined>(context: Context<TValue>): T => {
  const value = useContext<TValue>(context);
  if (value !== null && value !== undefined) {
    return value as T;
  } else {
    throw new Error(`No context provided for ${context.displayName}.`);
  }
};

export default useRequiredContext;
